import i18n from '~/i18n';
import taskUtils from '~/utils/task-utils';
import { store } from '~/store';
import { setSelectedTaskRowId } from '~/reducers/selectedTaskRowIdSlice';
import { resetSelectedMapStops } from '~/reducers/selectedMapStopsSlice';
import { makeMarkerPopup } from './makeMarkerPopup';
import { getMetricsFromStopOrTask } from '~/utils/stopUtils';

const getDelayConfig = (stop) => {
    const { isEarly, isOnTime, isAtRisk, isLate } = stop;
    if (isEarly)
        return {
            icon: 'clockFill',
            color: 'earth',
            text: 'markerPopup:status.early'
        };
    if (isOnTime)
        return {
            icon: 'clockFill',
            color: 'earth',
            text: 'markerPopup:status.onTime'
        };
    if (isAtRisk)
        return {
            icon: 'clockFill',
            color: 'venus',
            text: 'markerPopup:status.atRisk'
        };
    if (isLate)
        return {
            icon: 'clockFill',
            color: 'mars',
            text: 'markerPopup:status.late'
        };

    return { icon: null, color: null, text: null };
};

/**
 * Creates a `MarkerPopup` component for plan stops and unassigned tasks
 * @method makeStopPopup
 * @memberof module:utils/map/popupMaker
 * @param {*} payload - stop data (PlanStop or OnDemandDispatchStop)
 * @param {*} emittedEventHandler - the map emitted event handler
 * @returns {MarkerPopup}
 */
export const makeStopPopup = (payload, emittedEventHandler) => {
    const { location, stopMarkerData: planStop } = payload;

    const {
        arrivalTime,
        euid,
        // TODO: API needs to send back `serviceTimeML` for tasks
        isServiceTimeML,
        stopName,
        labels,
        taskId,
        volumeCapacityUsed,
        sizeByCompartment,
        clientId,
        size,
        twoPartTaskId,
        recommendationScore,
        numInventoryItems = 0
    } = planStop;

    const {
        icon: stopIcon,
        color: stopColor,
        text: stopText
    } = getDelayConfig(planStop);

    const etaTime = arrivalTime
        ? i18n.t('common:time.estimatedTime', {
              time: arrivalTime
          })
        : i18n.t('common:N/A');
    const { serviceTime, timeWindows } = getMetricsFromStopOrTask(planStop);

    // TODO: RP-719 Refactor to return React components
    const { isMultiCompartmentClient = false } =
        store.getState().accountSetupByClient[clientId] || {};

    const onClickStopDetailButton = () => {
        store.dispatch(resetSelectedMapStops());
        store.dispatch(setSelectedTaskRowId(twoPartTaskId || taskId));
    };

    const popupPayload = {
        className: 'stop-popup',
        testId: 'stop-popup',
        location,
        stopData: {
            stopColor,
            stopText: i18n.t(stopText),
            stopName,
            stopIcon,
            etaTime,
            labels,
            isMultiCompartmentClient,
            sizeByCompartment,
            timeWindows,
            serviceTime: `${serviceTime} ${i18n.t('common:time.minutes')}`,
            isServiceTimeML,
            MLServiceTimeChipText: i18n.t('markerPopup:machineLearned'),
            routeId: taskUtils.getEuid(euid),
            volumeCapacityUsed: volumeCapacityUsed ?? size,
            stopDetailButtonText: i18n.t('markerPopup:button.moreDetail'),
            onClickStopDetailButton,
            numInventoryItems,
            taskId,
            recommendationScore
        }
    };

    return makeMarkerPopup(popupPayload, emittedEventHandler);
};
